var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled, css } from '@creditas-ui/react';
var listItemStyle = function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  list-style: none;\n  user-select: none;\n  color: ", ";\n  padding: ", " ", ";\n"], ["\n  cursor: pointer;\n  list-style: none;\n  user-select: none;\n  color: ", ";\n  padding: ", " ", ";\n"])), theme.colors.neutral[60], theme.spacingY.xl, theme.spacingX['6xl']);
};
var activeListItemStyle = function (_a) {
    var theme = _a.theme, active = _a.active, disabled = _a.disabled;
    return active &&
        !disabled && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: bold;\n    background-color: #defaed;\n  "], ["\n    color: ", ";\n    font-weight: bold;\n    background-color: #defaed;\n  "])), theme.colors.neutral[100]);
};
var disabledListItemStyle = function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    cursor: not-allowed;\n  "], ["\n    cursor: not-allowed;\n  "])));
};
export var ListItem = styled.li(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  ", "\n  ", "\n  ", "\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), listItemStyle, activeListItemStyle, disabledListItemStyle, function (_a) {
    var theme = _a.theme;
    return '#DEFAED';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=TabItem.style.js.map